import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useApp } from "../../../../AppProvider";
import DeleteIcon from "../../../Setting/SettingsAssets/Delete.svg";
import SeacrhIcon from "../../../Setting/SettingsAssets/Search.svg";
import "./MedicineMain.css";
import Loader from "../../../../Components/GlobalLoader/Loader";
import api from "./../../../../axiosInstance"
import Select from "react-select";
import logger from "../../../../utils/logger";


const adviceOptions = [
  "Take adequate rest and avoid physical exertion", "Ensure proper sleep of at least 7–8 hours daily", "Avoid overworking and manage stress levels", "Resume normal activity gradually after recovery",
  "Drink plenty of fluids and stay well hydrated", "Consume warm fluids like soup and herbal tea", "Follow a balanced and nutritious diet", "Avoid outside food,junk food,and oily items", "Eat small,frequent meals",
  "Include fruits and vegetables in daily diet", "Avoid alcohol and smoking", "Monitor body temperature regularly",
  "Do not self-medicate with antibiotics", "Complete the prescribed course of medicines", "Maintain proper personal hygiene",
  "Use mask in crowded places if advised", "Do steam inhalation twice daily", "Gargle with warm salt water",
  "Avoid cold drinks and cold exposure", "Avoid dust,smoke,and pollutants", "Avoid spicy and acidic food",
  "Take meals at regular intervals", "Do not skip meals", "Avoid lying down immediately after eating",
  "Maintain proper hand hygiene before meals", "Monitor blood pressure regularly", "Monitor blood sugar levels as advised",
  "Take medicines regularly without missing doses", "Maintain a healthy weight", "Follow lifestyle modification as advised",
  "Avoid heavy lifting and sudden movements", "Maintain correct posture while sitting and working", "Do light stretching exercises regularly", "Apply warm compress if advised", "Keep the affected area clean and dry", "Avoid scratching the affected area",
  "Use prescribed topical medications only", "Avoid sharing personal items", "Practice relaxation techniques such as meditation", "Engage in regular physical activity", "Limit screen time before sleep", "Seek emotional support from family and friends",
  "Avoid driving or operating machinery if dizzy", "Follow infection prevention measures", "Get routine health checkups", "Keep vaccinations up to date", "Report immediately if symptoms worsen", "Return for follow-up as advised", "Seek emergency care if severe symptoms occur",
  "Do not ignore persistent symptoms", "Take medicines only as prescribed", "Do not stop medicines without consultation", "Store medicines in a cool and dry place", "Maintain a health record for future reference"
];



const MedicineMain = ({ handleDeleteCard, selectedCard }) => {
  const menuPortalRef = useRef(null);
  const [tags, setTags] = useState(selectedCard?.tags || []);
  const [mediTableContent, setMediTableContent] = useState([]);
  const [labTableContent, setLabTableContent] = useState([]);
  const [advice, setAdvice] = useState(Array.isArray(selectedCard?.advice) ? selectedCard.advice : []);
  const [adviceInput, setAdviceInput] = useState("");
  const [groupName, setGroupName] = useState(selectedCard?.groupName || 'Group Details');
  const [loading, setLoading] = useState();
  const [popupMessage, setPopupMessage] = useState();
  const [showCustomForm, setShowCustomForm] = useState(false);
  const [customBrand, setCustomBrand] = useState('');
  const [customDrug, setCustomDrug] = useState('');

  const { searchMedicineData, searchQuery, setSearchQuery, fetchSearchMedicineAPI, setSearchMedicineData, setMedicationGroup,
    searchTestLab, fetchSearchTestLabAPI, searchQueryLab, setSearchQueryLab, setSearchTestLab, mediTableContentLabTest, setMediTableContentLabTest,
    prescriptionOptions } = useApp();

  logger.debug("selectedCard in MedicineMain:", selectedCard);

  const updateMedicineNewData = async (id, groupName, medicines, tests, advice, tags) => {
    // const apiUrl = `${process.env.REACT_APP_BASE_URL}/medicationGroups/${id}`;
    try {
      // console.log("BODY",{ groupName, medicines, tests, advice, tags })
      const response = await api.put(`/medicationGroups/${id}`, { groupName, medicines, tests, advice, tags })

      const data = response.data
      // console.log("Updated medicine new data:", data);
      return data
    } catch (error) {
      logger.error("Error updating medicine data:", error.message);
    }
  };

  useEffect(() => {
    if (selectedCard) {
      setGroupName(selectedCard.groupName || 'Group Details');
      setMediTableContent(selectedCard.medicines || []);
      setLabTableContent(selectedCard.tests || []);
      // setAdvice(selectedCard.advice || "");
      // setAdvice(Array.isArray(selectedCard.advice) ? selectedCard.advice : []); // ✅
      // ✅ Convert string advice to array
      if (Array.isArray(selectedCard.advice)) {
        setAdvice(selectedCard.advice);
      } else if (typeof selectedCard.advice === "string") {
        const adviceArray = selectedCard.advice
          .split("\n")
          .map(item => item.trim())
          .filter(item => item !== "");
        setAdvice(adviceArray);
      } else {
        setAdvice([]);
      }
      setTags(selectedCard.tags || []);
    }
  }, [selectedCard]);


  const handleSave = async () => {
    if (selectedCard && selectedCard._id) {
      setLoading(true);
      try {
        const updatedData = await updateMedicineNewData(selectedCard._id, groupName, mediTableContent, labTableContent, advice.join(", "), tags);
        setMedicationGroup(prevState =>
          prevState.map(item =>
            item._id === selectedCard._id
              ? updatedData
              : item
          )
        );
        setPopupMessage("Your medication has been updated successfully!");
      } catch (error) {
        logger.error("Error updating data:", error);
        setPopupMessage("Error updating data.");
      } finally {
        setLoading(false);
      }

    }
  };


  const handleTagsChange = (e) => {
    const value = e.target.value;
    const tagsArray = value.split(',').map(tag => tag.trim());
    setTags(tagsArray);
  };

  const handleHeadingChange = (e) => {
    const newGroupName = e.target.value;
    setGroupName(newGroupName);
    if (selectedCard) {
      selectedCard.groupName = newGroupName;
    }
  };


  const handleDeleteClickTableItem = (index) => {
    const updatedMediTableContent = mediTableContent.filter((item, idx) => idx !== index);
    setMediTableContent(updatedMediTableContent);
  };

  const handleDeleteLabTable = (index) => {
    const updateLabTableContent = labTableContent.filter((item, ide) => ide !== index);
    setLabTableContent(updateLabTableContent);
  }

  const handleAddCustomClick = () => {
    setSearchMedicineData([]);
    setCustomBrand(searchQuery);
    setCustomDrug('');
    setSearchQuery('');
    setShowCustomForm(true);
  };

  const handleCustomMedicineAdd = () => {
    if (!customBrand.trim()) return;
    const newMedicine = {
      serialNo: (mediTableContent.length + 1).toString(),
      skuId: null,
      brand: customBrand.trim(),
      drugsName: customDrug.trim(),
      quantity: '',
      duration: '',
      dosage: '',
      remarks: ''
    };
    setMediTableContent([...mediTableContent, newMedicine]);
    setShowCustomForm(false);
    setCustomBrand('');
    setCustomDrug('');
  };

  const handleResultClickMedication = (item) => {
    setSearchMedicineData([]);
    setSearchQuery(item.sku);
    const newMedicine = {
      serialNo: (mediTableContent.length + 1).toString(),
      brand: item.sku,
      drugsName: item.subGroup,
      quantity: "",
      duration: "",
      dosage: "",
      remarks: "",
      skuId: item._id
    };
    setMediTableContent([...mediTableContent, newMedicine]);
    setSearchQuery("");
  };


  const handleResultClickTestLab = (item) => {
    setSearchTestLab([]);
    setSearchQueryLab(item.testName);
    logger.debug("item", item)
    const newLabTest = {
      // serialNo: (labTableContent.length + 1).toString(),
      department: item.department,
      testId: item._id,
      test: item.canonicalName,

    };
    setLabTableContent([...labTableContent, newLabTest]);
    setSearchQueryLab('');
  }

  const handleInputChange = (index, columnKey, value) => {
    const updatedContent = mediTableContent.map((item, idx) => {
      if (idx === index) {
        return { ...item, [columnKey]: value };
      }
      return item;
    });
    setMediTableContent(updatedContent);
  };

  // SEARCH MEDICINE API CALL
  useEffect(() => {
    if (searchQuery.length >= 3) {
      fetchSearchMedicineAPI(searchQuery);
    } else {
      setSearchMedicineData([]); // Clear results if query length is less than 3
    }
  }, [searchQuery]);

  const handleSearchChangeBrandMedication = (event) => {
    const mediQuery = event.target.value;
    setSearchQuery(mediQuery);
  };

  // SEARCH LAB TEST API CALL
  useEffect(() => {
    if (searchQueryLab.length >= 3) {
      fetchSearchTestLabAPI(searchQueryLab);
    } else {
      setSearchTestLab([]); // Clear results if query length is less than 3
    }
  }, [searchQueryLab]);

  const handleSearchChangeLabTest = (event) => {
    const labQuery = event.target.value;
    setSearchQueryLab(labQuery);
  };

  const handlePopupClose = () => {
    setPopupMessage(null);
    setLoading(false);  // Stop the loader when the popup is dismissed
  };

  const renderAdvice = () => {
    if (!Array.isArray(advice)) return null;   // ✅ guard
    return advice.map((itemAdvice, index) => (
      <div key={index} className="appointment-card">
        {itemAdvice}
        <span
          className="card-remove"
          onClick={() => {
            const updated = advice.filter((_, i) => i !== index);
            setAdvice(updated);
          }}
        >
          x
        </span>
      </div>
    ));
  };


  const handleAdviceInputKeyDown = (e) => {
    if (!adviceInput) return;
    if (e.key === "Enter") {
      e.preventDefault();
      setAdvice((prev) => {
        const arr = Array.isArray(prev) ? prev : [];
        return arr.includes(adviceInput) ? arr : [...arr, adviceInput];
      });
      setAdviceInput("");
    }
  };


  return (
    <div className="medi_right_container" ref={menuPortalRef}>
      {(loading || popupMessage) && (
        <div className="popup-overlay">
          <div className="popup-content">
            {loading && <Loader message="Updating Your Medication Please Wait" />}
            {popupMessage && <p>{popupMessage}</p>}
            {popupMessage && <button onClick={handlePopupClose}>OK</button>}
          </div>
        </div>
      )}
      <div className="medi_right_section">
        <div className="medi_right_top">
          <Link className="backLink" to="/setting">
            <ArrowBackIosIcon className="back-button" />
            <div>Go Back</div>
          </Link>
          <input className="medi_right_heading"
            type="text"
            value={selectedCard === undefined ? "Group Details" : selectedCard ? selectedCard.groupName : "A"}
            onChange={handleHeadingChange}
          />
          <div className="medi_right_content">
            <div className="medi_search_inputbox">
              {/* SEARCH BAR BRAND MEDICINE */}
              <div className="medi_search_input">
                <img className="medi_search_icon" src={SeacrhIcon} alt="Search Icon" />
                <input
                  className="medi_input_search"
                  type="text"
                  placeholder="Search medicine brand"
                  value={searchQuery}
                  onChange={handleSearchChangeBrandMedication}
                />
                {(searchMedicineData.length > 0 || searchQuery.length >= 3) && !showCustomForm && (
                  <div className="medicine-search-results_medication">
                    <div className="medicine-brandsearch_medication medicine-custom-option" onClick={handleAddCustomClick}>
                      + Add &ldquo;{searchQuery}&rdquo; as custom medicine
                    </div>
                    {searchMedicineData.map((item, index) => (
                      <div
                        className="medicine-brandsearch_medication"
                        key={index}
                        onClick={() => handleResultClickMedication(item)}
                      >
                        <span className="medicine-brandsearch_medication-sku">{item.sku}</span>
                        <span className="medicine-brandsearch_medication-subgroup">{item.subGroup}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {/* SEARCH BAR LAB TEST */}
              <div className="medi_search_input">
                <img className="medi_search_icon" src={SeacrhIcon} alt="Search Icon" />
                <input
                  className="medi_input_search"
                  type="text"
                  placeholder="Search Lab test"
                  value={searchQueryLab}
                  onChange={handleSearchChangeLabTest}
                />
                {searchTestLab.length > 0 && (
                  <div className="medicine-search-results_medication">
                    {searchTestLab.map((item, index) => (
                      <div
                        className="medicine-brandsearch_medication"
                        key={index}
                        onClick={() => handleResultClickTestLab(item)}>
                        {item.canonicalName}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            {showCustomForm && (
              <div className="medicine-custom-form">
                <input
                  className="medicine-custom-input"
                  type="text"
                  placeholder="Brand name"
                  value={customBrand}
                  onChange={(e) => setCustomBrand(e.target.value)}
                />
                <input
                  className="medicine-custom-input"
                  type="text"
                  placeholder="Drug / generic name"
                  value={customDrug}
                  onChange={(e) => setCustomDrug(e.target.value)}
                />
                <div className="medicine-custom-actions">
                  <button className="medicine-custom-btn-cancel" onClick={() => { setShowCustomForm(false); setCustomBrand(''); setCustomDrug(''); }}>Cancel</button>
                  <button className="medicine-custom-btn-add" onClick={handleCustomMedicineAdd}>Add</button>
                </div>
              </div>
            )}
            <table className="medi_table-medication">
              <thead>
                <tr className="medi_tableheader-medication">
                  <td className="medi_header_text-medication medicineSNO-width">S.No.</td>
                  <td className="medi_header_text-medication medication__brand-width">Brand Name</td>
                  <td className="medi_header_text-medication medication__brand-width">Drug Name</td>
                  <td className="medi_header_text-medication">Quantity</td>
                  <td className="medi_header_text-medication">Duration</td>
                  <td className="medi_header_text-medication">Dosage</td>
                  <td className="medi_header_text-medication medicineSNO-width">Delete</td>
                </tr>
              </thead>
              <tbody>
                {mediTableContent.length > 0 ? (
                  mediTableContent.map((group, index) => (
                    <tr className="theBody-tr_medication" key={index}>
                      <td className="medi_table_el-medication">{index + 1}</td>
                      <td className="medi_table_el-medication">{group.brand}</td>
                      <td className="medi_table_el-medication">{group.drugsName}</td>

                      {/* Quantity */}
                      <td className="medi_table_el-medication">
                        <select
                          className="medicine-table-input"
                          value={group.quantity || ""}
                          onChange={(e) =>
                            handleInputChange(index, "quantity", e.target.value)
                          }
                        >
                          <option value="">Select quantity</option>
                          {(prescriptionOptions?.quantity || []).map(opt => (
                            <option key={opt} value={opt}>{opt}</option>
                          ))}
                        </select>
                      </td>

                      {/* Duration */}
                      <td className="medi_table_el-medication">
                        <select
                          className="medicine-table-input"
                          value={group.duration || ""}
                          onChange={(e) =>
                            handleInputChange(index, "duration", e.target.value)
                          }
                        >
                          <option value="">Select duration</option>
                          {(prescriptionOptions?.duration || []).map(opt => (
                            <option key={opt} value={opt}>{opt}</option>
                          ))}
                        </select>
                      </td>

                      {/* Dosage */}
                      <td className="medi_table_el-medication">
                        <select
                          className="medicine-table-input"
                          value={group.dosage || ""}
                          onChange={(e) =>
                            handleInputChange(index, "dosage", e.target.value)
                          }
                        >
                          <option value="">Select dosage</option>
                          {(prescriptionOptions?.dosage || []).map(opt => (
                            <option key={opt} value={opt}>{opt}</option>
                          ))}
                        </select>
                      </td>

                      {/* Delete */}
                      <td className="medi_table_el-medication">
                        <img
                          className="medicine-delete_icon_doctor"
                          src={DeleteIcon}
                          alt="deleteicon"
                          onClick={() => handleDeleteClickTableItem(index)}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="no_medicine_selected">
                      No Medicine Selected
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <table className="medi_table-lab">
              <thead>
                <tr className="medi_tableheader-lab">
                  <td className="medi_header_text-lab labTest-width">S.No.</td>
                  <td className="medi_header_text-lab">Test Name</td>
                  <td className="medi_header_text-lab">Lab Name</td>
                  <td className="medi_header_text-medication labTest-width">Delete</td>
                </tr>
              </thead>
              <tbody>
                {labTableContent.length > 0 ? (
                  labTableContent.map((group, index) => (
                    <tr className="theBody-tr_lab" key={index}>
                      <td className="medi_table_el-lab">{index + 1}</td>
                      <td className="medi_table_el-lab">{group.test}</td>
                      <td className="medi_table_el-lab">{group.department}</td>
                      <td className="medi_table_el-medication">
                        <img className="medicine-delete_icon_doctor"
                          src={DeleteIcon}
                          alt="deleteicon"
                          onClick={() => handleDeleteLabTable(index)}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="no_medicine_selected">No Test Selected</td>
                  </tr>
                )
                }
              </tbody>
            </table>
            <div className="medi_suggestion_label">Advice / Suggestions</div>
            <div className="medi_suggestionbox-advice">
              <Select
                isMulti
                placeholder="Advice"
                value={[]}                          // Always empty — selections go to cards below
                onChange={(selectedOptions) => {
                  const newItems = selectedOptions.map((opt) => opt.label);
                  // setAdvice((prev) => [...prev, ...newItems]);
                  setAdvice((prev) => [...(Array.isArray(prev) ? prev : []), ...newItems]); // ✅
                }}
                inputValue={adviceInput}
                onInputChange={(input, { action }) => {
                  if (action === "input-change") setAdviceInput(input);
                }}
                onKeyDown={handleAdviceInputKeyDown}
                options={adviceOptions.map((item) => ({
                  label: item,
                  value: item,
                }))}
                classNamePrefix="react-select"
                styles={{
                  menu: (base) => ({ ...base, height: 150 }),
                  menuList: (base) => ({ ...base, maxHeight: 150 }),
                }}
              />
              <div className="cards-container-advice">
                {renderAdvice()}
              </div>
            </div>


            <div className="medi_suggestionbox">
              <div className="medi_suggestion_label">
                Diagnosis
              </div>
              <div className="medi_suggestion_inputbox">
                <textarea
                  className="medi_suggestion_input"
                  type="text"
                  placeholder="Add Diagnosis here "
                  value={tags}
                  onChange={handleTagsChange}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="btn_box">
          <div
            className="medi_btn_deletebox"
            onClick={() => handleDeleteCard()}
          >
            <div className="medi_btn_deletetext">Delete</div>
          </div>
          <div className="medi_btn_savebox">
            <div className="medi_btn_savetext" onClick={handleSave}>Save</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MedicineMain;
